export default __webpack_public_path__ + "static/media/user.d95b55e9.svg";